import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

// Shared
import { BodyMedium, H3, H4 } from '@styled';
import SubmitButton from '@atoms/SubmitButton';
import SearchMembersByEmail from '@molecules/SearchMembersByEmail';

// Functionality
import { EventRegistrationContext } from '../EventRegistrationProvider';

const EventRegistrationSearchByEmail = ({ hideButton, eventCode, onSuccessfulSearch }) => {
    const { setRegistrationEmail, setSearchResultCountForEmail } = useContext(EventRegistrationContext);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSearchCompleted = ({ email, count }) => {
        if (eventCode === '2024LASVEGAS') {
            // Trigger pixel code
            const pixelSrc = 'https://sp.analytics.yahoo.com/spp.pl?a=10000&.yp=10150340&he={INSERT_MACRO_HERE}&hph={INSERT_MACRO_HERE}&ec=lv24continueemailbutton';

            // Create a new image element
            const img = new Image();

            // Set the src attribute to the pixel URL
            img.src = pixelSrc;

            console.log(`Register Link Clicked. Sent Pixel for ${eventCode}`);
            // Append the image to the document body to trigger pixel request
            document.body.appendChild(img);
        }

        if (eventCode === '2024NY') {
            // Trigger pixel code
            const pixelSrc = 'https://sp.analytics.yahoo.com/spp.pl?a=10000&.yp=10150340&he={INSERT_MACRO_HERE}&hph={INSERT_MACRO_HERE}&ec=icsc24contemail';

            // Create a new image element
            const img = new Image();

            // Set the src attribute to the pixel URL
            img.src = pixelSrc;

            console.log(`Register Link Clicked. Sent Pixel for ${eventCode}`);
            // Append the image to the document body to trigger pixel request
            document.body.appendChild(img);
        }

        setRegistrationEmail(email);
        setSearchResultCountForEmail(count);

        onSuccessfulSearch(email, count);
    };

    return (
        <div>
            <H3>Event Registration</H3>
            <H4 className="mt-1.125rem">Enter Your Email</H4>
            <BodyMedium className="mb-1rem mt-1rem">Already have an account? We'll prompt you to log in.</BodyMedium>
            <div style={{ maxWidth: '400px' }}>
                <SearchMembersByEmail onSearchCompleted={onSearchCompleted} onSubmittingChange={setIsSubmitting} />
            </div>

            {!hideButton && (
                <SubmitButton buttonClasses="mt-0" isSubmitting={isSubmitting} submittingText="Checking email...">
                    Continue with email
                </SubmitButton>
            )}
        </div>
    );
};

EventRegistrationSearchByEmail.propTypes = {
    hideButton: PropTypes.bool,
    eventCode: PropTypes.string,
    onSuccessfulSearch: PropTypes.func.isRequired,
};

export default EventRegistrationSearchByEmail;
